import { Bookmark, Bell, Users, Menu } from 'lucide-react';
import { useChatStore } from '../../store/chatStore'; // adjust path if needed
import { useState, useRef, useEffect } from 'react';
import logo from "../../assets/images/NitorLogo.png";

function Navbar() {
  const {
    activeRole,
    setRole,
    sidebarOpen,
    setSidebarOpen,
  } = useChatStore();

  const [showRoleMenu, setShowRoleMenu] =
    useState(false);

  const menuRef = useRef(null);

  useEffect(() => {
    const handler = (e) => {
      if (
        menuRef.current &&
        !menuRef.current.contains(e.target)
      ) {
        setShowRoleMenu(false);
      }
    };

    document.addEventListener('mousedown', handler);
    return () =>
      document.removeEventListener(
        'mousedown',
        handler
      );
  }, []);

  return (
    <header
      className="h-16 flex items-center justify-between px-4 md:px-6 relative"
      style={{
        background: '#0d1b2e',
        borderBottom:
          '1px solid rgba(255,255,255,0.08)',
      }}
    >
      {/* Left */}
      <div className="flex items-center gap-3">
        <button
          className="md:hidden p-2"
          onClick={() =>
            setSidebarOpen(!sidebarOpen)
          }
        >
          <Menu size={22} color="white" />
        </button>

        <div className="flex flex-col leading-tight chatbot-header">
          <a target="_blank" rel="noreferrer" href="/">
            <img alt="Nitor Infotech" class="logo-image" src={logo} />
          </a>
        </div>
      </div>

      {/* Center */}
      <span
        className="hidden md:block text-sm"
        style={{
          fontFamily: 'PPNeueMachina',
          fontWeight: 600,
          fontSize: '16px',
          color: '#fff',
          background: 'linear-gradient(to right, #6666CC 11%, #CC0066 100%)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
        }}
      >
        NIA (Nitor Intelligent Assistant)
      </span>

      {/* Right */}
      <div className="flex items-center gap-2">
        {/* {[Bookmark, Bell].map((Icon, i) => (
          <button
            key={i}
            className="w-10 h-10 rounded-full flex items-center justify-center transition-colors"
            style={{ background: '#00C8D4' }}
            onMouseEnter={(e) =>
            (e.currentTarget.style.background =
              '#00A8B5')
            }
            onMouseLeave={(e) =>
            (e.currentTarget.style.background =
              '#00C8D4')
            }
          >
            <Icon size={18} color="white" />
          </button>
        ))} */}

        <div className="relative" ref={menuRef}>
          <button
            className="w-10 h-10 rounded-full flex items-center justify-center transition-colors"
            style={{ background: 'linear-gradient(264.28deg, #00fac2 -38.2%, #66c 103.12%)' }}
            onClick={() =>
              setShowRoleMenu(!showRoleMenu)
            }
            onMouseEnter={(e) =>
            (e.currentTarget.style.background =
              'linear-gradient(264.28deg, #00fac2 -38.2%, #66c 103.12%)')
            }
            onMouseLeave={(e) =>
            (e.currentTarget.style.background =
              'linear-gradient(264.28deg, #00fac2 -38.2%, #66c 103.12%)')
            }
          >
            <Users size={18} color="white" />
          </button>

          {showRoleMenu && (
            <div
              className="absolute right-0 top-12 z-50 rounded-lg p-1 min-w-[160px]"
              style={{
                background: '#1a2a40',
                border:
                  '1px solid rgba(255,255,255,0.15)',
              }}
            >
              {['pre_sales', 'marketing'].map(
                (r) => (
                  <button
                    key={r}
                    className="w-full text-left px-3 py-2 rounded-md text-[13px] transition-colors"
                    style={{
                      background:
                        activeRole === r
                          ? r === 'pre_sales'
                            ? 'rgba(0,200,212,0.15)'
                            : 'rgba(245,197,24,0.15)'
                          : 'transparent',
                      color:
                        activeRole === r
                          ? r === 'pre_sales'
                            ? '#00fac2'
                            : '#00fac2'
                          : 'rgba(255,255,255,0.70)',
                    }}
                    onClick={() => {
                      setRole(r);
                      setShowRoleMenu(false);
                    }}
                  >
                    {r === 'pre_sales'
                      ? '🤝 Pre-Sales'
                      : '📣 Marketing'}
                  </button>
                )
              )}
            </div>
          )}
        </div>
      </div>
    </header>
  );
}

export default Navbar;